import { useState, useEffect, useMemo, useRef } from 'react';
import { callServerToGetUrls, processItems, converItemsToProGalleryItems } from '../../utils/itemsProcessor';
import ItemsDimensionsHelper from '../../utils/itemsDimensionsHelper';
const itemContainsMedia = item => !!item.mediaUrl || item.metaData && !!item.metaData.html; // filter out items that dont have a mediaUrl/ html for text
const itemsDimensionsHelper = new ItemsDimensionsHelper();
const BATCH_SIZE = 50;
export const useItems = function (items, itemsSrc, batchSize, getMoreItemsFromSource, isExternalPagination) {
  if (batchSize === void 0) {
    batchSize = BATCH_SIZE;
  }
  const allProGalleryItems = useMemo(() => {
    return converItemsToProGalleryItems(items, itemsSrc);
  }, [items, itemsSrc]);
  const getPaginateItems = () => isExternalPagination ? allProGalleryItems : allProGalleryItems.slice(0, batchSize);
  const [itemsToRender, setItemsToRender] = useState(processItems(getPaginateItems()).items);
  const itemsToRenderRef = useRef(itemsToRender);
  const setItemsToRenderAndUpdateRef = items => {
    setItemsToRender(items);
    itemsToRenderRef.current = items;
  };
  useEffect(() => {
    prepareAndSetItems(getPaginateItems());
  }, [allProGalleryItems]);
  const prepareAndSetItems = function (newItems, currentItems) {
    if (currentItems === void 0) {
      currentItems = [];
    }
    const {
      items: itemsToSet,
      shouldGetVideoUrls
    } = processItems(newItems);
    filterAndThenSetItemsToRender(currentItems.concat(itemsToSet));
    if (shouldGetVideoUrls) {
      callServerToGetUrls({
        newItems,
        currentItems
      }).then(filterAndThenSetItemsToRender);
    }
    itemsDimensionsHelper.loadItemsDimensionsIfNeeded(itemsToRenderRef.current, setItemsToRenderAndUpdateRef);
  };
  const getMoreItemsFromItemPool = async from => {
    return getItemsFromPool(from);
  };
  const getItemsFromPool = async from => {
    return allProGalleryItems.slice(from, from + batchSize);
  };
  const getMoreItemsFromItemsSource = from => {
    const getMoreItemsFunc = getMoreItemsFromSource || getMoreItemsFromItemPool;
    return getMoreItemsFunc(from).then(_items => {
      addItems(_items, from);
    });
  };
  const addItems = (addedItems, from) => {
    const curItems = itemsToRenderRef.current;
    prepareAndSetItems(addedItems, curItems.slice(0, from || curItems.length) // do not double append items
    );
  };
  const filterAndThenSetItemsToRender = itemsToSet => {
    const _items = itemsToSet.filter(itemContainsMedia);
    setItemsToRenderAndUpdateRef(_items || itemsToRenderRef.current);
  };
  const handleGetMoreItemsRequest = from => {
    getMoreItemsFromItemsSource(from);
  };
  const addExternalItems = newItems => {
    addItems(converItemsToProGalleryItems(newItems, itemsSrc));
  };
  return {
    itemsToRender,
    handleGetMoreItemsRequest,
    addExternalItems
  };
};
//# sourceMappingURL=itemsHelper.js.map